/* Presentation adapter for the existing Klaviyo popup. Klaviyo owns all events,
 * targeting, validation, submission, focus management and subsequent steps. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.init(root.document);
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var instances = new WeakMap();
  function init(doc) {
    if (instances.has(doc)) return instances.get(doc);
    var win = doc.defaultView;
    function copy(key) { return win?.PlaygeniI18n?.text('signup.' + key + '_html') || ''; }
    function row(node, name) {
      var parent = node && node.closest('[data-testid="form-row"]');
      if (parent) parent.classList.add('pg-signup__' + name);
    }
    function text(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }
    function update() {
      doc.querySelectorAll('form[data-testid="klaviyo-form-ST864a"]').forEach(function (form) {
        var modal = form.closest('[data-testid="modal-form-container"]');
        if (!modal) return;
        modal.classList.add('pg-signup-modal');
        // Klaviyo scales the original 400px + margins on small screens. Let the
        // responsive card reflow instead, preserving readable text/touch targets.
        for (var wrapper = modal.parentElement; wrapper && wrapper !== doc.body; wrapper = wrapper.parentElement) {
          if (wrapper.style.position === 'fixed') {
            wrapper.classList.add('pg-signup-overlay');
            break;
          }
          if (wrapper.style.transform.indexOf('scale(') !== -1) wrapper.classList.add('pg-signup-scale');
          wrapper.classList.add('pg-signup-wrapper');
        }
        form.classList.add('pg-signup');
        var email = form.querySelector('input[type="email"]');
        var heading = form.querySelector('h1');
        var isOffer = email && heading && (/Get 10% off/i.test(heading.textContent) || heading.textContent === copy('heading') || heading.dataset.pgSignupHeading === 'true');
        form.classList.toggle('pg-signup--email', !!isOffer);
        if (!isOffer) return;
        row(form.querySelector('.klaviyo-form-image'), 'photo');
        row(heading, 'heading');
        heading.dataset.pgSignupHeading = 'true';
        // Keep the native rich-text structure; only change the existing text leaf.
        text(heading.querySelector('span') || heading, copy('heading'));
        heading.setAttribute('aria-label', copy('heading_label'));
        form.querySelectorAll('.klaviyo-form-richtext').forEach(function (block) {
          if (/Stock is limited|Pre-order your storymaker/.test(block.textContent)) {
            row(block, 'intro');
            text(block.querySelector('span') || block.querySelector('p'), copy('intro'));
          } else if (/No spam\. Unsubscribe anytime\./.test(block.textContent)) row(block, 'helper');
        });
        row(email, 'email');
        if (email.placeholder !== copy('email_placeholder')) email.placeholder = copy('email_placeholder');
        text(form.querySelector('label[for="' + email.id + '"]'), copy('email_label'));
        form.querySelectorAll('button[data-action-id]').forEach(function (button) {
          if ((/^(Get My Code|Get my 10% off)$/.test(button.textContent.trim()) || button.dataset.pgSignupSubmit === 'true')) {
            row(button, 'submit'); button.dataset.pgSignupSubmit = 'true'; text(button, copy('button'));
          }
        });
      });
    }
    var observer = win && win.MutationObserver ? new win.MutationObserver(update) : null;
    if (observer) observer.observe(doc.body, {childList: true, subtree: true, characterData: true});
    function stop() { if (observer) observer.disconnect(); instances.delete(doc); }
    instances.set(doc, stop);
    update();
    return stop;
  }
  return {init: init};
});
